<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Airline Update",
      items: [
        {
          text: "Airline",
          href: "/",
        },
        {
          text: "Entry",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      airlineid: "",
      errors: null,
        visible:false,
        message:"",
        lineError:true,
      form: {
        airline_name: "",
        airline_code: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      airline_name: {
        required,
      },
      airline_code: {
        required,
      },
    },
  },

  created() {
    this.airlineid = this.$route.params.id;
  },
  mounted() {
    this.getAirlineDetail();
  },

  methods: {
      onClose(){
          this.visible=false;
      },
    async getAirlineDetail() {
      try {
        axios
          .post("/api/airline/profile/" + this.airlineid, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
              this.form.airline_name = data.name;
              this.form.airline_code = data.code;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/airline/update", {
          id: this.airlineid,
          name: this.form.airline_name,
          code: this.form.airline_code,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.airlineUpdateForm.reset();
            this.$swal("Good job!", "Airline Updated", "success");
            this.$router.push({ name: "all_airlines" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="airlineUpdateForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="airline_name">Airline Name</label>
                    <input
                      id="airline_name"
                      v-model="form.airline_name"
                      name="airline_name"
                      type="text"
                      class="form-control"
                      placeholder="Type airline name"
                      value="form.airline_name"
                      :class="{ 'is-invalid': submitted && $v.form.airline_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.airline_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.airline_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="airline_code">Airline Code</label>
                    <input
                      id="airline_code"
                      v-model="form.airline_code"
                      name="airline_code"
                      type="text"
                      class="form-control"
                      placeholder="Type code"
                      value="form.airline_code"
                      :class="{ 'is-invalid': submitted && $v.form.airline_code.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.airline_code.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.airline_code.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Update</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
